import {CatalogService} from './CatalogService';
import {AppEntities, AppServices} from "../../config/entities";
import {generateUrlWithParams} from "../../helpers/UrlHelper";
import {IProductDto} from "../../dtos/catalogs/Products/IProductDto";
import {ProductTypeEnum} from "../../enums/Products/ProductTypeEnum";

export class ProductService extends CatalogService {
    async GetAllNotGroups(searchText: string | undefined, productType: ProductTypeEnum | undefined): Promise<IProductDto> {
        const url = generateUrlWithParams(AppEntities.Product.apiUrl, {searchText, takeGroups: false, productType});
        const response = await AppServices.Axios.get(url);
        return response.data;
    }

    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = {...newObject};
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
